import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/img/folderdocs.svg'
import _imports_1 from '@/img/starmini.svg'
import _imports_2 from '@/img/eye.svg'
import _imports_3 from '@/img/pencil.svg'


const _hoisted_1 = { class: "box scrollBox d-flex flex-column justify-content-between" }
const _hoisted_2 = { class: "boxTitle mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "float-right"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "ml-1",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "tagsContainer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "mx-1",
  src: _imports_1
}
const _hoisted_8 = { class: "list-group" }
const _hoisted_9 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = {
  key: 0,
  class: "docreadLabel"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-1",
  src: _imports_1
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Nuovo ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "fs-14" }
const _hoisted_16 = { class: "fs-14" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href", "onClick"]
const _hoisted_25 = {
  key: 0,
  class: "docreadLabel"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-1",
  src: _imports_1
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Nuovo ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "fs-14" }
const _hoisted_30 = { class: "fs-14" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$store.state.isAdmin())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-shadow",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openGestioneDocs && _ctx.openGestioneDocs(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Gestisci documenti",
                text: "Gestisci documenti"
              }),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_localized_text, {
        localizedKey: "Documenti / Circolari",
        text: "Documenti / Circolari"
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tag", { selected: _ctx.selectedFolder == item.name }]),
                onClick: ($event: any) => (_ctx.selectedFolder = item.name),
                key: i
              }, [
                _createTextVNode(_toDisplayString(item.name ? item.name : 'Tutti') + " ", 1),
                (item.hasNew)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.documentiDashboard.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun documento caricato",
                    text: "Nessun documento caricato"
                  })
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentiDashboard, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-group-item",
                key: i
              }, [
                (item.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item.url,
                      class: "d-flex justify-content-between",
                      target: "_blank",
                      onClick: ($event: any) => (_ctx.setReadDoc(item))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _createElementVNode("small", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
                          (_ctx.isRead(item))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_14))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("b", null, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(item.description), 1)
                      ]),
                      (_ctx.$store.state.isAdmin())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-shadow btn-sm",
                              onClick: _withModifiers(($event: any) => (_ctx.openReadModal(item)), ["stop","prevent"])
                            }, _hoisted_20, 8, _hoisted_18),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-shadow btn-sm ml-1",
                              onClick: _withModifiers(($event: any) => (_ctx.openEditModal(item)), ["stop","prevent"])
                            }, _hoisted_23, 8, _hoisted_21)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: item.attachment.publicUrl,
                      class: "d-flex justify-content-between",
                      target: "_blank",
                      onClick: ($event: any) => (_ctx.setReadDoc(item))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _createElementVNode("small", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
                          (_ctx.isRead(item))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("b", null, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.description), 1)
                      ]),
                      (_ctx.$store.state.isAdmin())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-shadow btn-sm",
                              onClick: _withModifiers(($event: any) => (_ctx.openReadModal(item)), ["stop","prevent"])
                            }, _hoisted_34, 8, _hoisted_32),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-shadow btn-sm ml-1",
                              onClick: _withModifiers(($event: any) => (_ctx.openEditModal(item)), ["stop","prevent"])
                            }, _hoisted_37, 8, _hoisted_35)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_24))
              ]))
            }), 128))
          ])
        ], 64))
  ]))
}